import _regeneratorRuntime from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/eazyads-player/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import { Message } from 'element-ui';
import { getToken, setToken, setUserID, getUserID } from '@/utils/auth';
import { Device } from '@capacitor/device';
import i18n from '@/lang';
var version = 'v1';
var langcode = i18n.locale;
export var base_url = process.env.VUE_APP_BASE_API + '/' + version;

// create an axios instance
var service = axios.create({
  baseURL: base_url,
  // url = base url + request url
  withCredentials: false,
  // send cookies when cross-domain requests
  timeout: 5000,
  // request timeout
  crossDomain: false
});

// --- Convert JSON Object into "application/x-www-form-urlencoded"
// https://gist.github.com/akexorcist/ea93ee47d39cf94e77802bc39c46589b
var transformRequest = function transformRequest() {
  var jsonData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(jsonData).map(function (x) {
    return "".concat(encodeURIComponent(x[0]), "=").concat(encodeURIComponent(x[1]));
  }).join('&');
};
// ---

// request interceptor
service.interceptors.request.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
    var default_args, lang, token, id;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // do something before request is sent
          default_args = {};
          if (config.params !== undefined && config.data === undefined) {
            if (config.method !== 'get') {
              // Correction: use only for POST-Params (and PATCH & co. but not GET) when there is no payload to send

              // if params is JSON-Object convert into "application/x-www-form-urlencoded"
              if (config.params instanceof Object) {
                config.params = transformRequest(config.params);
              }

              // Post params as urlencoded body
              if (config.method !== 'get') {
                config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                config.data = config.params;
                config.params = undefined;

                // --- Geraeteinfo auslesen (devid, ...)
                default_args = transformRequest(default_args);
                if (config.data === undefined) {
                  config.data = default_args;
                } else {
                  config.data += '&' + default_args;
                }
                // console.log(info)
                // ---
              }
            } else {
              // 21.10.2019 19:00 - Don't send default_args with GET or backend won't respond
            }
          }
          // --- Sprachcode des Geraets auslesen
          langcode = i18n.t('langcode');
          if (!(langcode === undefined)) {
            _context.next = 9;
            break;
          }
          _context.next = 6;
          return Device.getLanguageCode();
        case 6:
          lang = _context.sent;
          console.log(lang.value);
          langcode = lang.value.split[0];
        case 9:
          // ----
          token = getToken();
          if (token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['X-Token'] = token;
          }
          id = getUserID();
          if (id) config.headers['X-ID'] = id;
          config.headers['Accept-Language'] = langcode;
          config.requestStartTime = Date.now();
          return _context.abrupt("return", config);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;
  if (response.config && response.config.requestStartTime) response.config.requestTime = Date.now() - response.config.requestStartTime;
  if ((!response.config || !response.config.silent) && res.errors) {
    Message({
      message: res.errors || 'Error',
      type: 'error',
      duration: 5 * 1000
    });
  }
  if (response.headers['x-token']) {
    setToken(response.headers['x-token']);
  }
  if (response.headers['x-id']) {
    setUserID(response.headers['x-id']);
  }
  if (response.config && response.config.raw) return response;
  return res;
}, /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(error) {
    var msg;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!error.config || !error.config.silent)) {
            _context2.next = 15;
            break;
          }
          _context2.prev = 1;
          if (!(error.response.data instanceof Blob)) {
            _context2.next = 8;
            break;
          }
          _context2.t0 = JSON;
          _context2.next = 6;
          return error.response.data.text();
        case 6:
          _context2.t1 = _context2.sent;
          error.response.data = _context2.t0.parse.call(_context2.t0, _context2.t1);
        case 8:
          msg = error.response.data.message || error.response.data.errors[0];
          _context2.next = 14;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t2 = _context2["catch"](1);
          try {
            msg = error.message;
          } catch (e) {
            msg = error.statusText || error.status;
          }
        case 14:
          Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
          });
        case 15:
          return _context2.abrupt("return", Promise.reject(error));
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 11]]);
  }));
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());
export default service;
export function isUploadProgressAvailable() {
  // Workaround for axios bug in line 1123 https://github.com/axios/axios/blob/master/dist/axios.js
  var r = new XMLHttpRequest();
  if (r.upload && r.upload.addEventListener) {
    return true;
  } else {
    return false;
  }
}